import React, { useEffect, useState } from 'react';
import Theme from 'Theme';
import { Icon as RNVIcon } from 'renative';
import { View, SafeAreaView } from 'react-native';
import type { BottomTabBarProps } from '@react-navigation/bottom-tabs';
import NavigationService from 'NavigationService';
import { useAppSelector } from 'ReduxStore/hooks';
import defaultStyle from './tabBar.jss';
import TabBarButton from './tabBarButton';
import { DETAIL_HEADER_HEIGHT, MINIMISED_OFFSET } from './Menu/Menu.styles';
import { Device } from 'DeviceUtils';

interface TabBarBottomProps extends BottomTabBarProps {
    showBackButton: boolean;
    activeBackgroundColor: string;
    inactiveBackgroundColor: string;
    // eslint-disable-next-line @typescript-eslint/ban-types
    inactiveLabelStyle: object;
    getAccessibilityLabel?: any; // TODO: FIX ME
    navigation: any; // TODO: FIX ME
    getTestID?: any; // TODO: FIX ME
    jumpTo?: any; // TODO: FIX ME
    onTabLongPress?: any; // TODO: FIX ME
    labelStyle?: any; // TODO: FIX ME
    getLabelText?: any; // TODO: FIX ME
    haveTitle?: boolean;
}
const TabBarBottom = ({
    navigation,
    activeBackgroundColor,
    inactiveBackgroundColor,
    showBackButton,
    jumpTo,
    onTabLongPress,
    labelStyle,
    inactiveLabelStyle,
    getLabelText,
    getTestID,
    getAccessibilityLabel,
    haveTitle,
}: TabBarBottomProps): JSX.Element => {
    const isMinimised = useAppSelector((state) => state.webMenu.isMinimised);
    const { routes, index } = navigation.getState();
    return (
        <SafeAreaView style={[
            defaultStyle.tabBarContainer,
            isMinimised ? { transform: `translateY(-${MINIMISED_OFFSET}px)` } : {},
            Device.isWeb && haveTitle ? {
                marginTop: defaultStyle.tabBarContainer.marginTop as number + DETAIL_HEADER_HEIGHT
            } : {}]}
        >
            <View style={defaultStyle.iconContainer}>
                {showBackButton ? (
                    <RNVIcon
                        iconFont="materialIcons"
                        iconName="keyboard-arrow-left"
                        iconColor={Theme.primaryTextColor}
                        style={defaultStyle.icon}
                        onPress={() => {
                            NavigationService.getAppNavigationInstance().pop();
                        }}
                    />
                ) : undefined}
            </View>
            <View style={defaultStyle.innerContainer}>
                {routes.map((route, mapIndex) => {
                    const focused = mapIndex === index;
                    const accessibilityLabel = getAccessibilityLabel({
                        route
                    });
                    const label = getLabelText({ route });
                    let labelString = '';
                    if (label && typeof label === 'string') {
                        labelString = label;
                    }
                    const testID = getTestID({ route }) || labelString?.replace(/ /g, '_');

                    const backgroundColor = focused
                        ? activeBackgroundColor
                        : inactiveBackgroundColor;
                    const style = focused ? labelStyle : inactiveLabelStyle;

                    return (
                        <TabBarButton
                            key={route.key}
                            onPress={() => jumpTo(route.key)}
                            onLongPress={() => onTabLongPress({ route })}
                            testID={testID}
                            accessibilityLabel={accessibilityLabel}
                            label={labelString}
                            labelStyle={style}
                            stripColor={backgroundColor}
                        />
                    );
                })}
            </View>
            <View style={defaultStyle.separator} />
        </SafeAreaView>
    );
};

export default TabBarBottom;
